/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { nullReducer, payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLEAR_ACCOUNT, SET_ACCOUNT_EMAIL, SET_ACCOUNT_NEXT } from './constants'
import { signInReducer } from './modules/signIn/reducer'
import { signUpReducer } from './modules/signUp/reducer'
import type { AccountState, ActionTypes } from './types'

export const accountReducer = combineReducers<AccountState, ActionTypes>({
  email: handleActions<AccountState['email'], ActionTypes>(
    { [CLEAR_ACCOUNT]: nullReducer, [SET_ACCOUNT_EMAIL]: payloadReducer },
    null
  ),
  next: handleActions<AccountState['next'], ActionTypes>(
    { [CLEAR_ACCOUNT]: nullReducer, [SET_ACCOUNT_NEXT]: payloadReducer },
    null
  ),
  signIn: signInReducer,
  signUp: signUpReducer,
})
